import React, { useEffect, useMemo } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { NoItemsPanel, PageContentPreloader, PageLayout, SearchPanel } from 'common/components';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import noPaymentsImage from 'common/images/noPayments.svg';
import { boGetUserChallenges } from '../../_redux';
import { BoProptradingTable } from '../../_components';

const ProptradingPage = ({ userChallenges, userChallengesAreLoaded, getUserChallenges, location, history }) => {
  const query = useMemo(
    () => ({
      page_size: 10,
      ...queryString.parse(location.search),
    }),
    [location.search]
  );

  useEffect(() => {
    getUserChallenges({ search: query });
  }, [getUserChallenges, query]);

  const handleRowClick = (_, row) => {
    history.push(`/backoffice/proptrading/${row.original.id}/`);
  };

  return (
    <PageLayout
      captionSlug="boProptrading"
      showReload
      onReloadClick={() => getUserChallenges({ search: query })}
      reloading={!userChallengesAreLoaded}>
      <PageContentPreloader ready={userChallengesAreLoaded} type="smallLines" firstLaunchOnly>
        {!userChallenges.count && !Object.keys(query).length ? null : (
          <SearchPanel
            location={location}
            history={history}
            getList={getUserChallenges}
            params={{ search: query }}
            searchTextId="boProptradingSearch"
          />
        )}

        {userChallenges.count ? (
          <BoProptradingTable
            data={userChallenges}
            loading={!userChallengesAreLoaded}
            location={location}
            history={history}
            getList={getUserChallenges}
            onRowClick={handleRowClick}
            params={{ search: query }}
          />
        ) : (
          <NoItemsPanel icon={noPaymentsImage} captionSlug="noChallenges" />
        )}
      </PageContentPreloader>
    </PageLayout>
  );
};

ProptradingPage.propTypes = {
  userChallenges: PropTypes.object.isRequired,
  getUserChallenges: PropTypes.func.isRequired,
  userChallengesAreLoaded: PropTypes.bool.isRequired,
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

export default compose(
  withRouter,
  connect(
    state => ({
      userChallenges: state.backoffice.proptrading.userChallenges,
      userChallengesAreLoaded: state.backoffice.proptrading.userChallengesAreLoaded,
    }),
    {
      getUserChallenges: search => boGetUserChallenges.request(search),
    }
  )
)(ProptradingPage);
